module.exports = __webpack_public_path__ + "img/code_icon.62eabfc4.svg";